module.exports = __webpack_public_path__ + "static/media/male-yellow.a9dcd807.svg";